// Single source of truth for form-field length limits. Unit tests assert
// rendered maxLength attributes against these constants — drift fails CI.
//
// password.max = 72 matches bcrypt's truncation boundary, which is what
// Strapi users-permissions hashes with. Anything past 72 bytes adds no
// security and only costs compute.
export const FORM_LIMITS = {
  password: { min: 10, max: 72 },
  signupDisplayName: { max: 80 },
  groupName: { max: 100 },
  groupDescription: { max: 2000 },
  // Matches the `cost` maxLength on the event schema, and the limit already
  // used for the Provider cost field the events one was modelled on.
  eventCost: { max: 100 },
  // The admin activity-log search term is sent three times in one query
  // string (one $containsi per searched field), and AWS WAF rejects query
  // strings over 2048 bytes. 60 UTF-16 units of the worst-case character
  // (3 UTF-8 bytes, 9 bytes percent-encoded) keep the whole query under that
  // ceiling; activity-log-search.test.ts measures it.
  activityLogSearch: { max: 60 },
} as const;
